import React, { useEffect, useRef, useState } from 'react'
import cn from 'clsx'
import { Typography, Tooltip } from '@pw-tech/omni-ui'
import styles from '../index.module.css'
import { InfinityCardItemProps } from '../../../utils/types'
import { TooltipPosition } from '../../../utils/enum'
import {
  CheckmarkIcon,
  InfoCircleIcon,
  useDeviceSize,
} from '../../../utils/utilities'

const InfinityCardItem: React.FC<InfinityCardItemProps> = ({
  itemData,
  index,
  variant,
  isRecommended,
  containerWidth,
  isSinglePlan,
  isProPlan,
}) => {
  const [width] = useDeviceSize()
  const textRef = useRef<HTMLDivElement | null>(null)
  const [tooltipPosition, setTooltipPosition] = useState<TooltipPosition>(
    TooltipPosition.Center
  )

  // Recalculate tooltip position whenever containerWidth changes
  useEffect(() => {
    if (containerWidth && textRef.current) {
      const textWidth = textRef.current.offsetWidth
      const textPosition = textRef.current.offsetLeft
      if (
        textWidth >= containerWidth * 0.4 ||
        textPosition >= containerWidth * 0.7
      ) {
        setTooltipPosition(TooltipPosition.Right)
      } else {
        setTooltipPosition(TooltipPosition.Center)
      }
    }
  }, [containerWidth, itemData.description])

  const cardWrapper = cn(styles.CardWrapper, {
    [styles.CardWrapperFlex]: itemData.enabled,
    [styles.CardWrapperHidden]: !itemData.enabled,
  })

  return (
    <div className={cardWrapper} key={itemData.item}>
      <img src={CheckmarkIcon} alt="checkmark" />
      <div ref={textRef}>
        <Typography
          component="div"
          color="static-white"
          variant="small"
          weight={variant === 'infinity' && index === 0 ? 'bold' : 'medium'}
        >
          {itemData?.item}
        </Typography>
      </div>
      {itemData.description && (
        <div className="relative">
          <div
            className={styles.CardDescription}
            data-tooltip-id={`anchor-${index}`}
            data-tooltip-delay-show={400}
          >
            <Tooltip
              label={<img src={InfoCircleIcon} alt="" />}
              onClose={function noRefCheck() {}}
              open={false}
              origin={tooltipPosition}
              position="bottom"
              showCloseIcon={false}
              variant="light"
              style={{
                maxWidth: width <= 640 ? '214px' : '270px',
                overflow: 'hidden',
              }}
            >
              <div className={styles.ToolTip}>
                <Typography
                  color="text-body-1"
                  component="div"
                  variant="small"
                  className={styles.ToolTipText}
                >
                  {itemData.description}
                </Typography>
              </div>
            </Tooltip>
          </div>
        </div>
      )}
    </div>
  )
}

export default InfinityCardItem
